module.exports = __webpack_public_path__ + "static/media/showroom.2c09ea2b.png";